import React, { Component } from "react";

class AssignedCustomersItem extends Component {

	render() {
		const {item, index} = this.props;

		return (
			<div className="customer-item" key={index}>
				<div className="customer-item-text">{item.fname + " " + item.lname + " (" + item.email +  ")"}</div>
				<button className="icon-cross" onClick={() => this.props.removeCustomer(index)}></button>
			</div>
		);
	}
}

export default AssignedCustomersItem;



// WEBPACK FOOTER //
// ./src/components/admin/top-tiers/customers/AssignedCustomersItem.js